import React from "react";
import PropTypes from "prop-types";

const ItemListCard = ({ title, url, isUpdate, isBreaking }) => (
  <div className="card is-list-section">
    <div className="card__content">
      {isUpdate && <span className="card__label label is-update">update</span>}
      {isBreaking && (
        <span className="card__label label is-breaking">breaking</span>
      )}
      {title && (
        <h3 className="card__title">
          <a className="card__title-link" href={url}>
            {title}
          </a>
        </h3>
      )}
    </div>
  </div>
);

ItemListCard.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  isUpdate: PropTypes.bool.isRequired,
  isBreaking: PropTypes.bool.isRequired,
};

export default ItemListCard;
